import { createRouter } from '@tanstack/react-router';

import { routeTree } from './routeTree.gen';

// Set up a Router instance
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultStaleTime: 5000,
  scrollRestoration: true,
  defaultViewTransition: {
    types: ({ fromLocation, toLocation }) => {
      let direction = 'none';

      if (fromLocation) {
        const fromIndex = fromLocation.state.__TSR_index;
        const toIndex = toLocation.state.__TSR_index;

        direction = fromIndex > toIndex ? 'right' : 'left';
      }

      return [`slide-${direction}`];
    },
  },
});

// Register things for typesafety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
